import { render, staticRenderFns } from "./CDCommits.vue?vue&type=template&id=00d627f9&scoped=true"
import script from "./CDCommits.vue?vue&type=script&lang=ts"
export * from "./CDCommits.vue?vue&type=script&lang=ts"
import style0 from "./CDCommits.vue?vue&type=style&index=0&id=00d627f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d627f9",
  null
  
)

export default component.exports